import { ArrowBackOutlined } from '@mui/icons-material'
import {
  Button,
  ButtonGroup,
  Checkbox,
  Chip,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import { CurrencyInput } from '../helper'
import './TechnicalRequest.css'

const COLUMN_WIDTHS = {
  CHECKBOX: '42px',
  NUMBER: '60px',
  CLIN: '170px',
  DESCRIPTION: '290px',
  CLIN_TYPE: '166px',
  DISCOUNT_CLASS: '270px',
  LIST_PRICE: '153px',
  SEWP_PRICE: '153px',
  DISCOUNT_PCT: '214px',
  EPEAT_FLAG: '271px',
  ENERGY_STAR_FLAG: '195px',
  TAA_FLAG: '187px',
}

export default function TechnicalRequest() {
  return (
    <>
      <div className="tr-header">
        <div>
          <IconButton>
            <ArrowBackOutlined />
          </IconButton>
          <Typography variant="h6">Technical Request</Typography>
          <Chip label={`TR #: ${'TODO'}`} />
          <Chip label={`Date Submitted: ${'TODO'}`} />
        </div>
        <ButtonGroup variant="contained">
          <Button>Reset</Button>
          <Button>Submit Request</Button>
        </ButtonGroup>
      </div>
      <TableContainer className="tr-table-container">
        <Table
          stickyHeader
          sx={{ minWidth: `${Object.values(COLUMN_WIDTHS).reduce((acc, curr) => acc + parseInt(curr), 0)}px` }}
        >
          <TableHead>
            <TableRow>
              <TableCell className="checkbox-column" width={COLUMN_WIDTHS.CHECKBOX}>
                <Checkbox />
              </TableCell>
              <TableCell
                className="number-column"
                sx={{ left: `calc(${COLUMN_WIDTHS.CHECKBOX} + 32px)` }}
                width={COLUMN_WIDTHS.NUMBER}
              >
                #
              </TableCell>
              <TableCell
                className="clin-column"
                sx={{ left: `calc(${COLUMN_WIDTHS.CHECKBOX} + ${COLUMN_WIDTHS.NUMBER} + 32px)` }}
                width={COLUMN_WIDTHS.CLIN}
              >
                Validation #
                <br />
                (OEM + MFR Part #)
              </TableCell>
              <TableCell sx={{ minWidth: COLUMN_WIDTHS.DESCRIPTION }}>Description</TableCell>
              <TableCell width={COLUMN_WIDTHS.CLIN_TYPE}>CLIN Type</TableCell>
              <TableCell width={COLUMN_WIDTHS.DISCOUNT_CLASS}>Discount Class</TableCell>
              <TableCell width={COLUMN_WIDTHS.LIST_PRICE}>List Price</TableCell>
              <TableCell width={COLUMN_WIDTHS.SEWP_PRICE}>SEWP Price</TableCell>
              <TableCell width={COLUMN_WIDTHS.DISCOUNT_PCT}>Discount PCT</TableCell>
              <TableCell width={COLUMN_WIDTHS.EPEAT_FLAG}>EPEAT Flag</TableCell>
              <TableCell width={COLUMN_WIDTHS.ENERGY_STAR_FLAG}>Energy Star Flag</TableCell>
              <TableCell width={COLUMN_WIDTHS.TAA_FLAG}>TAA Flag</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: 10 }).map((_, index) => (
              <TableRow key={index}>
                <TableCell className="checkbox-column">
                  <Checkbox />
                </TableCell>
                <TableCell className="number-column" sx={{ left: `calc(${COLUMN_WIDTHS.CHECKBOX} + 32px)` }}>
                  {index + 1}
                </TableCell>
                <TableCell
                  className="clin-column"
                  sx={{ left: `calc(${COLUMN_WIDTHS.CHECKBOX} + ${COLUMN_WIDTHS.NUMBER} + 32px)` }}
                >
                  TODO
                </TableCell>
                <TableCell>
                  <TextField size="small" fullWidth />
                </TableCell>
                <TableCell>
                  <TextField select size="small" fullWidth>
                    <MenuItem value="TODO">TODO</MenuItem>
                  </TextField>
                </TableCell>
                <TableCell>
                  <CurrencyInput value={null} onChange={() => false} size="small" />
                </TableCell>
                <TableCell>
                  <CurrencyInput value={null} onChange={() => false} size="small" />
                </TableCell>
                <TableCell>
                  <CurrencyInput value={null} onChange={() => false} size="small" />
                </TableCell>
                <TableCell>
                  <TextField size="small" fullWidth />
                </TableCell>
                <TableCell>
                  <TextField select size="small" fullWidth>
                    <MenuItem value="TODO">TODO</MenuItem>
                  </TextField>
                </TableCell>
                <TableCell>
                  <TextField select size="small" fullWidth>
                    <MenuItem value="TODO">TODO</MenuItem>
                  </TextField>
                </TableCell>
                <TableCell>
                  <TextField select size="small" fullWidth>
                    <MenuItem value="TODO">TODO</MenuItem>
                  </TextField>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
